import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../pay-icon/icon.component';
import { IconNames } from '../pay-icon/IconNames';
import { SetupTwoFactorAuthAppComponent } from './setup-two-factor-auth-app/setup-two-factor-auth-app.component';
import { SetupTwoFactorAuthSmsComponent } from './setup-two-factor-auth-sms/setup-two-factor-auth-sms.component';

@Component({
  selector: 'pay-login-setup-two-factor-auth-chooser',
  imports: [IconComponent, TranslateModule, NgClass, SetupTwoFactorAuthSmsComponent, SetupTwoFactorAuthAppComponent],
  templateUrl: './setup-two-factor-auth-chooser.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetupTwoFactorAuthChooserComponent {
  activeSetup: 'app' | 'sms' = 'app';

  toggleActiveSetup() {
    if (this.activeSetup === 'app') {
      this.activeSetup = 'sms';
      return;
    }
    this.activeSetup = 'app';
  }
  protected readonly IconNames = IconNames;
  mfaBearer = input.required<string>();
}
